import { Component } from '@angular/core'

@Component({
  selector: 'op-carousel',
  templateUrl: './carousel.component.html',
  styleUrls: ['./carousel.component.scss'],
})
export class CarouselComponent {}
